import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';
import { IPutImageCollectionRequestBody } from '@types';

interface IPutImageCollectionResponse {
  isCollected: boolean;
}

async function putImageCollection(variables: {
  imageId: number;
  body: IPutImageCollectionRequestBody;
}): Promise<AxiosResponse<FetchResult<IPutImageCollectionResponse>>> {
  const response = await instance.put(`/images/${variables.imageId}/collections`, variables.body);
  return response;
}

const usePutImageCollection = (
  onSuccess?: (
    data: AxiosResponse<FetchResult<IPutImageCollectionResponse>>,
    variables: { imageId: number; body: IPutImageCollectionRequestBody }
  ) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['put', `/images/:imageId/collections`],
    mutationFn: (variables: { imageId: number; body: IPutImageCollectionRequestBody }) => putImageCollection(variables),
    onSuccess: (data, variables) => {
      onSuccess?.(data, variables);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePutImageCollection;
